import React, { memo } from "react";
// components
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
// types
import { DEFAULT_ERROR_TITLE, DEFAULT_ERROR_MESSAGE, ERROR_IMAGE_ID } from "./constants";
import { IFullWidthButtonVariant } from "@swiggy-private/dls-web-core/dist/components/FullWidthButton/types";
import { DATA_TEST_ID } from "./constants";
// styles
import {
    Container,
    ImageContainer,
    Title,
    Subtitle,
    ButtonContainer,
    PrimaryAction,
    SecondaryAction,
    Wrapper,
} from "./styles";
// helpers
import { isEmpty } from "@swiggy-private/js-utils";
// hooks
import { useEffectOnce } from "@core-ui/hooks/UseEffectOnce";

interface GiftingCartErrorAction {
    variant: IFullWidthButtonVariant;
    onClick: () => void;
    text: string;
}

interface GiftingCartErrorProps {
    title?: string;
    subtitle?: string;
    imageId?: string;
    primaryAction?: GiftingCartErrorAction;
    secondaryAction?: GiftingCartErrorAction;
    impressionEventCallback?: () => void;
}

const GiftingCartError = ({
    impressionEventCallback,
    title = DEFAULT_ERROR_TITLE,
    subtitle = DEFAULT_ERROR_MESSAGE,
    imageId = ERROR_IMAGE_ID,
    primaryAction,
    secondaryAction,
}: GiftingCartErrorProps) => {
    useEffectOnce(() => {
        if (impressionEventCallback) {
            impressionEventCallback?.();
        }
    });

    return (
        <Container data-testid={DATA_TEST_ID.CONTAINER}>
            <Wrapper>
                <ImageContainer data-testid={DATA_TEST_ID.IMAGE}>
                    <Image cloudinaryId={imageId || ERROR_IMAGE_ID} alt="Gifting Cart Error" />
                </ImageContainer>
                {!isEmpty(title) && (
                    <Title
                        data-testid={DATA_TEST_ID.ERROR_TITLE}
                        variant="V2.heading2.neutral.black"
                        color="text_Highest_Emphasis"
                    >
                        {title}
                    </Title>
                )}
                {!isEmpty(subtitle) && (
                    <Subtitle
                        data-testid={DATA_TEST_ID.ERROR_SUBTITLE}
                        variant="V2.body2.neutral.regular"
                        color="text_Med_Emphasis"
                    >
                        {subtitle}
                    </Subtitle>
                )}
                <ButtonContainer>
                    {!isEmpty(primaryAction) && (
                        <PrimaryAction
                            data-testid={DATA_TEST_ID.ERROR_PRIMARY_ACTION}
                            variant={primaryAction.variant}
                            onClick={primaryAction.onClick}
                        >
                            {primaryAction.text}
                        </PrimaryAction>
                    )}
                    {!isEmpty(secondaryAction) && (
                        <SecondaryAction
                            data-testid={DATA_TEST_ID.ERROR_SECONDARY_ACTION}
                            variant={secondaryAction.variant}
                            onClick={secondaryAction.onClick}
                        >
                            {secondaryAction.text}
                        </SecondaryAction>
                    )}
                </ButtonContainer>
            </Wrapper>
        </Container>
    );
};

export default memo(GiftingCartError);
